export const isEnterKey = (e: React.KeyboardEvent | KeyboardEvent): boolean =>
  e.key === "Enter" ||
  (e as React.KeyboardEvent & { keyCode?: number }).keyCode === 13 ||
  (e as React.KeyboardEvent & { keyCode?: number }).keyCode === 108;
